import React, {useState,useEffect,memo} from 'react';
import { withRouter } from "react-router-dom"
import { LinkContainer } from 'react-router-bootstrap';
import { isSet } from '../../Utils/CommonFunctions';
import {getWindowIcons,getProfileAuthorities,getUserAuthorities,getCurrentModuleId,clearGoBackURL, getUserInfo} from '../../Utils/UserFunctions';
import Wrp from "../../hoc/Wrp/Wrp";
import ReminderList from './ReminderList';
import Icons from "../Icons/Icons";
import WindowIcons from '../Icons/WindowIcon';
import $ from 'jquery';


const OTHER_MENUS = [{
	name:'Reports',
	icon:"Reports",
	class:`nav-item tab_focus svgIconFill`,
	url:'/reports'
},{
	name:'Documents',
	icon:"Contacts",
	class:`nav-item tab_focus svgIconFill`,
	url:'/documents'
}]

const LeftNav = memo((props) => {
	const [toggleSideBarShow, setToggleSideBarShow] = useState(false);
	const [toggleLeftMenuShow, setToggleLeftMenuShow] = useState(false);
	const [leftMenuData,setLeftMenuData] = useState([]);
	const [dataJSONPayload,setDataJSONPayload] = useState({
		"windowAccess": {
        "profile": "Community Partners",
        "restrictedWindows": [
            "carrier",
            "invoices",
            "additional services"
        ]
    }
	});
	const [reminderMessage,setReminderMessage] = useState(null);
	const [leftMoreMenuData,setLeftMoreMenuData] = useState([]);

	
	const userAuthorities = getUserAuthorities();
	const currentModuleId = getCurrentModuleId();
	let userDefaultMod = '';
	let userModule = (userAuthorities != null && userAuthorities.data) ? userAuthorities.data.map((arr,i) => {
		if(arr.id === currentModuleId)
		{
			userDefaultMod = arr.module_name;
		}
	}):[];
	const currentURL = props.history.location.pathname;
	const getURLDetails = isSet(currentURL,'').split('/');
	
	useEffect(()=>{
		fetch(`/data.json`)
		.then((response) => response.json())
		.then((jsonData) => { setDataJSONPayload(jsonData) })
		.catch((error) => console.error('Error fetching JSON:', error));
	},[]);

	useEffect(()=>{
		updateMenuData();
	},[props.menuData,props.showItems,dataJSONPayload]);
	
	useEffect(()=>{
		updateMenuData();
	},[props.match.params]);

	const updateMenuData = ()=>{
		let ii = 0;
		let moreMenuData = [];
		let leftMenuData = [];
		let restrictedMenus = [];
		const {windowAccess} = dataJSONPayload;
		try{
			if(getUserInfo().data.profile_name===isSet(windowAccess.profile,'')){
				restrictedMenus = isSet(windowAccess.restrictedWindows,[]);
			 }
		}catch(e){

		}
		
		let menuWindowList = isSet(props.menuData,[]);
		//Menu Sorting based on display priority
		// menuWindowList.sort((a, b) => (a.display_priority > b.display_priority) ? 1 : -1);
		const sortedMenuList = [...menuWindowList].sort((a, b) => {
                  return a.display_priority - b.display_priority;
            });
		//Menu Iterate
		// console.log('menuWindowList',menuWindowList);
		sortedMenuList.map((arr,i) => {
			if(restrictedMenus.indexOf(arr.window_name.toString().toLowerCase())!==-1){
				return false;
			}
			// check window access for logged in profile or not..
			const allowIndexing = isSet(arr.profiles,[]).findIndex((i=>i.authority_name==='View'));
			let isAllowAccess  	= isSet(isSet(arr.profiles,[])[allowIndexing].is_selected,true);
   			let actClass 		= '';
			let actClassMore 	= '';
			let svgIcons = isSet(getWindowIcons(),[]);
			let sourceImage =   "";
			let htmlCode = "";
			svgIcons.map((item,i)=>{
				if(item.id===arr.window_icon){
					htmlCode = item.html_code;
					sourceImage= 'data:image/svg+xml;base64,'+item.svg_icon;	
				}
			});						
			if(getURLDetails[1]!=='settings' && getURLDetails[2] === arr.window_name){
				actClass = 'active'; 
				actClassMore= 'd-flex active align-items-center'; 
			}
			
			if(isAllowAccess === true || isAllowAccess === 'true'){
				if(ii < props.showItems){
					leftMenuData.push(
						   <LinkContainer to="#" key={i}>
							   <li onClick={goToWindowList.bind(this,arr,props)} className={`nav-item tab_focus svgIconFill ${actClass}`} to={arr.window_name}>
							   <a className="cursor-pointer" data-title={arr.window_name}>
									   {/* <Icons iconType={arr.window_name} /> */}
									   {isSet(arr.window_icon,null)!==null?(!arr.system_icon?
									<img src={sourceImage}  width='18' height='18' />
									// <div className="Container" dangerouslySetInnerHTML={{__html: htmlCode}}></div>
								   :<WindowIcons  windowIcon={arr.window_icon} size={18} />):
									<Icons iconType={arr.window_name} />
									 } 
   
									   <div className={toggleLeftMenuShow === false ? "windowName" : "windowName aaa"}> {arr.window_name} </div>
								   </a>
							   </li>
						   </LinkContainer>
					   )
				}else{
					   moreMenuData.push(
						   <LinkContainer to="#" key={i}>
							   <div className={`item ${actClassMore}`} id={'winId_'+i} onClick={goToWindowList.bind(this,arr,props)} to={arr.window_name} title={arr.window_name}>
								   {/* <Icons iconType={arr.window_name} /> */}
								   {isSet(arr.window_icon,null)!==null?(!arr.system_icon?
									<img src={sourceImage}  width='18' height='18' />
									// <div className="Container" width='18' height='18' dangerouslySetInnerHTML={{__html: htmlCode}}></div>

								   :<WindowIcons  svgIcons = {svgIcons} isSystemIcon={arr.system_icon} size={18} windowIcon={arr.window_icon}/>):
									<Icons iconType={arr.window_name} />
									 } 
								   <span className="pl-2 text-truncate">{arr.window_name}</span>	
							   </div>							
						   </LinkContainer>
					   )	
				}
			ii++;		
			}			   
		});
		OTHER_MENUS.map((arr,i) => {
			let actClass = '';
			let actClassMore = '';	
			let sourceImage =   "";
			let htmlCode = "";
			if(restrictedMenus.indexOf(arr.name.toString().toLowerCase())!==-1){
				return false;
			}
			let svgIcons = isSet(getWindowIcons(),[]);
			svgIcons.map((item,i)=>{
				if(item.id===arr.window_icon){
					// console.log("sItem",item);
					htmlCode = item.html_code;
					sourceImage= 'data:image/svg+xml;base64,'+item.svg_icon;	
				}
			});
			if(getURLDetails[1]!=='settings' && getURLDetails[2] === arr.name){ 
				actClass = 'active'; 
				actClassMore= 'd-flex active align-items-center'; 
			}
			if(ii < props.showItems){
			   leftMenuData.push(
			   <LinkContainer to={arr.url} onClick={e => toggleSideBarClose2(0)} key={i}>
				   <li className={arr.class+' '+actClass} to={arr.url}>
				   <a className="cursor-pointer" data-title={arr.name}>
						   {/* <Icons iconType={arr.icon} /> */}
						   {isSet(arr.window_icon,null)!==null?(!arr.system_icon?
									<img src={sourceImage}  width='18' height='18' />
									// <div className="Container" dangerouslySetInnerHTML={{__html: htmlCode}}></div>
								:<WindowIcons size={18}  windowIcon={arr.window_icon}/>):
							<Icons iconType={arr.icon} />
							} 

						   <div className="windowName"> {arr.name} </div>
					   </a>
				   </li>
			   </LinkContainer>
			   )
		   }else{
			   moreMenuData.push(
				   <LinkContainer to={arr.url} onClick={e => toggleSideBarClose2(0)} key={i+ii}>
					   <div className={`item ${actClassMore}`}  to={arr.url}>
						   {/* <Icons iconType={arr.icon} /> */}
						   {isSet(arr.window_icon,null)!==null?(!arr.system_icon?
									<img src={sourceImage}  width='18' height='18' />
									// <div className="Container" dangerouslySetInnerHTML={{__html: htmlCode}}></div>
								:<WindowIcons  size={18} windowIcon={arr.window_icon}/>):
							<Icons iconType={arr.icon} />
							} 
						   <span className="pl-2 text-truncate">{arr.name}</span>	
					   </div>
				   </LinkContainer>
			   )	
		   }
		   ii++;	
		});
		setLeftMenuData(leftMenuData);
		setLeftMoreMenuData(moreMenuData);
	}


	const toggleSideBar2  = () => {	
		if(toggleSideBarShow === false){
			$("#scripted").focus();	
			setToggleSideBarShow(true);
		}
		
	}

	const goToWindowList = (param,props)=>{
		let userLayouts = [];
		const profileInfo = getProfileAuthorities();
		try{
			if(profileInfo!==undefined && profileInfo.data!==undefined && profileInfo!=='' && profileInfo.data!==''){			
				profileInfo.data.user_profile_layout.map((item,index)=>{
					if(param.window_id===item.window_id && item.is_active===true){ 
						clearGoBackURL();
						toggleSideBarClose2(0);
						userLayouts.push(item.layout_id);
						props.history.push("/layouts/"+param.window_name+"/"+param.window_id+"/list/"+item.layout_id+'/'+Math.floor(Math.random() * 100) + 1);
					}
				})
			}
		}catch(e){

		}
	}

	const toggleSideBarClose2 = (flag) => {
		if(flag === 0){
			setToggleSideBarShow(false);	
		}
	}

	const toggleSideBarOpen2 = () => {
		setToggleSideBarShow(true);	
	}
	const reminderListPopupToogle = (bool)=>{
		if(bool===true){
			$('.reminderNotifyBox').show();
		}else{
			$('.reminderNotifyBox').hide();
		}
	}

	// if(!toggleLeftMenuShow){
	// 	if($(".wrapper").hasClass("sidebar_minimize")){
	// 		setToggleLeftMenuShow(!toggleLeftMenuShow);
	// 		setTimeout(() => {
	// 			checkHight(!toggleLeftMenuShow);
	// 		}, 200);	
	// 	}	
	// }
	
	
	const menuDataHandler = async () => {
		const val = !toggleLeftMenuShow;
		if(val === true) {
			$(".wrapper").addClass("sidebar_minimize");
		}else {
			$(".wrapper").removeClass("sidebar_minimize");
		}
		await setToggleLeftMenuShow(val);
		checkHight(val);
		
	}

	const checkHight = (val) => {
		const height = document.getElementById('sssssss').clientHeight;
		props.showItemsHanlder(height,val);
	}

	

	

	 let menuDataLength = leftMoreMenuData.length;
	 let ACTIVITY_REMINDER = {};
	 let activityReminder  = localStorage.getItem('ACTIVITY_REMINDER');
	 try{
		 if(activityReminder!==null && activityReminder!==undefined){
			 ACTIVITY_REMINDER =JSON.parse(activityReminder);
		 }
	 }catch(e){

	 }
	 let settingClass = (getURLDetails[1]==='settings')? 'active':'';
	
	//  console.log('userInfo',userInfo);
	return (

		<Wrp>
			<div className="sidebar sidebar-style-2">
				{/*logo*/}
				{/* <div className="logo"> */}
					<span className="toggleArrow" onClick={menuDataHandler}>
			 			{/*<button className="btn btn-toggle py-0" >  toggle-sidebar */}
			 				{
			 				toggleLeftMenuShow === false ?
			 				<i className="fas fa-angle-double-right" ></i>
			 				:
			 				<i className="fas fa-angle-double-left" ></i>
			 				}
			 			{/* </button> */}
					</span>
					{/* <span className="companyName" title={userDefaultMod}>
			 			{userDefaultMod}
					</span> */}
				{/* </div> */}
				{/*logo*/}

				{/*menu part*/}
				<div className="sideMenu" id="sssssss">
					<ul className="nav nav-primary" style={{paddingTop:'4rem'}}>
						{leftMenuData}

						<LinkContainer to="/settings">
							<li className={`nav-item tab_focus svgIconFill ${settingClass} `}  to="/settings">
								<a className="cursor-pointer" data-title="Settings">
									<Icons iconType="Settings" />
									<div className="windowName"> Settings </div>
								</a>
							</li>
						</LinkContainer>
					</ul>
					{ toggleSideBarShow===false?	
						menuDataLength > 0 ?
						<div className="nav nav-primary moreMenu svgIconFill">
						<div className="nav-item tab_focus">
							<a href="#" data-title="More Menu's" onClick={toggleSideBar2}>
								<div id="sideOpen"  >
									<Icons iconType="ActionMore" />
								</div>
							</a>
						</div>
						</div>
						: ''
						:
						menuDataLength > 0 ?
						<div className="nav nav-primary moreMenu">
						   <div className="nav-item tab_focus">
							   <a href="#" data-title="More Menu's`">
								   <Icons iconType="ActionMore" />
							   </a>
						   </div>
						   </div>					
						   : ''
						}
				</div>
				{/*menu part*/}

				<div className="bNotify">
					<a href="#" onClick={()=>reminderListPopupToogle(true)}>
						<Icons iconType="Reminder" />
					</a>
					<span className="notification">{Object.keys(ACTIVITY_REMINDER).length}</span>
				</div>
			</div>
			<div className="sidebar2" tabIndex="0" id="scripted" onBlur={e => toggleSideBarClose2(0)}>
				<div id="sideBox" className={toggleSideBarShow === true ? "active" : ""}> 
					<div id="sideClose" onClick={e => toggleSideBarClose2(0)} className={toggleSideBarShow === true ? "active" : ""}>
						<div id='top'></div>
						<div id='middle'></div>
						<div id='bottom'></div>
					</div>
					<div id="items">
						{leftMoreMenuData}	
					</div>
				</div>
			</div>
			<ReminderList 
				reminderListPopupToogle={reminderListPopupToogle}
				ACTIVITY_REMINDER={ACTIVITY_REMINDER}
				setReminderMessage={setReminderMessage}
				/>
		</Wrp>
	);
});

export default withRouter(LeftNav);